
import store, { storeModules } from "../store";
//@ts-ignore
import Worker from 'worker-loader!./app.worker.js';
// import Worker from './worker.js';

export interface ILogEventDataModel {
    FormName: string;
    FormId: string | number;
    Action: string;
    Comment: object;
}

export class LogEventDataModel implements ILogEventDataModel {
    FormName: string;
    FormId: string | number;
    Action: string;
    Comment: object;
    constructor(props: ILogEventDataModel) {
        Object.assign(this, props);
    }
}

interface IWorkerMessageModel {
    type: string;
    authInfo?: object;
    eventData?: ILogEventDataModel;
}

class WorkerMessageModel implements IWorkerMessageModel {
    type: string;
    authInfo: object;
    eventData: ILogEventDataModel;
    constructor(props: IWorkerMessageModel) {
        Object.assign(this, props);
        Object.assign(this.eventData.Comment, {
            locationPath: location.href
        })
    }
}
export default class EventTracker {
    //@ts-ignore


    static worker = window['Worker'] ? new Worker() : null;
    static logEvent(event: ILogEventDataModel) {
        try {
            window['dataLayer'].push({
                'event': 'OmniEventTracking',
                'gaEventAction': event.Action,
                'gaEventCategory': event.FormName,
                'gaEventValue': event.FormId
            });
            const authInfo = store.state[storeModules.Common].authTransfer;
            if (this.worker && authInfo) {
                const newEvent = new WorkerMessageModel({
                    authInfo: authInfo,
                    type: 'LogEvent',
                    eventData: event
                })
                this.worker.postMessage(newEvent);
            }
        } catch (error) {
            
        }
    }
}